module.exports = __webpack_public_path__ + "img/logoBanner.2708863a.png";